import { type PostContentObjectList, isGroupPostContentObjectList } from 'models';
import { useMemo } from 'react';
import { createCommunityOption } from '../../utils';
import type { PostFormValues } from '../PostForm';

export const useGetInitialValues = (postContentObject?: PostContentObjectList): Partial<PostFormValues> =>
  useMemo(() => {
    const [community] =
      (postContentObject && !isGroupPostContentObjectList(postContentObject)
        ? postContentObject.postInCommunities
        : undefined) ?? [];

    return {
      attachments: { files: postContentObject?.attachments ?? [], loading: false },
      community: community ? createCommunityOption(community) : undefined,
      htmlContent: postContentObject?.post.htmlContent ?? '',
      pinned: postContentObject?.pinned ?? false,
      textContent: postContentObject?.post.textContent,
    };
  }, [postContentObject]);
